import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

pageTitleStyles.titleText = {
    css: css`
        opacity: 1;
        color: rgba(0, 110, 210, 1);
        font-family: Poppins;
        font-size: 28px;
        font-weight: 500;
        font-style: normal;
        letter-spacing: 1px;
        text-align: left;
        text-transform: uppercase;
        margin-bottom: 15px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-bottom: 10px;
                `,
                css`
                    margin-bottom: 10px;
                `,
                css`
                    margin-bottom: 10px;
                `,
                null,

                null,
            ])}
    `,
};

pageTitleStyles.brandGridItem = mergeToNew(pageTitleStyles.brandGridItem, {
    width: 12,
    css: css`
        display: none;
    `,
});
